/* eslint-disable import/prefer-default-export */
export const SET_GOAL_TYPES_LIST = 'SET_GOAL_TYPES_LIST';
export const SET_GOAL_TYPES_LEVELS_LIST = 'SET_GOAL_TYPES_LEVELS_LIST';

export const SET_GOAL_TABLE_LIST = 'SET_GOAL_TABLE_LIST';
export const REMAP_GOAL_TABLE_LIST = 'REMAP_GOAL_TABLE_LIST';
export const SET_GOAL_TABLE_VALUES = 'SET_GOAL_TABLE_VALUE';
